import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PillBadge from "../global/PillBadge";
import ButtonGoPopup from '../popup/ButtonGoPopup';
import LiveIndic from "./LiveIndic";

import { displaySgzSpecificDetailPanelSelector } from './state/displaySgzSpecificDetailPanelSelector';
import { sgzMarkerDataSelector } from '../markers/state/sgzMarkerDataSelector';
import { sgzMarkerRealTimeSelector } from '../markers/state/sgzMarkerRealTimeSelector';
import { userLocationSelector } from '../markers/state/userLocationSelector';

import { toggleSgzSpecificDetailPanel } from './state/displaySgzSpecificDetailPanelAction'
import { showDetailPanelContainer } from '../detailsPanel/state/displayDetailsPanelContainerAction'

import * as global from '../global/globalVariable'
import { getDriveTimeAndPath, getWalkingTime } from '../global/MapUtils';

import * as IoIcon from 'react-icons/io5';
import * as MdIcon from 'react-icons/md';
import './ParkingSpecificDetailsPanel.css'


function SgzSpecificDetailsPanel({ map }) {

    const dispatch = useDispatch()

    const displaySgzPanel = useSelector(displaySgzSpecificDetailPanelSelector)
    const sgzMarkerData = useSelector(sgzMarkerDataSelector)
    const sgzMarkerRealTime = useSelector(sgzMarkerRealTimeSelector)
    const userLocation = useSelector(userLocationSelector)

    const [staticData, setStaticData] = useState()
    const [dynamicData, setDynamicData] = useState()
    const [drivingTime, setDrivingTime] = useState("-")
    const [walkingTime, setWalkingTime] = useState("-")
    const [pillColor, setPillColor] = useState("")
    const [pillText, setPillText] = useState("")
    const [showPopupButtonGo, setShowPopupButtonGo] = useState(false)

    function closePanel() {
        dispatch(toggleSgzSpecificDetailPanel({ value: false, streetId: "" }))
        dispatch(showDetailPanelContainer())
    }

    useEffect(() => {
        if (!displaySgzPanel.value) return

        const streetId = displaySgzPanel.streetId
        const sgzStatic = sgzMarkerData[streetId]
        setStaticData(sgzStatic)

        const sgzDynamic = sgzMarkerRealTime[streetId]
        setDynamicData(sgzDynamic)

        if (sgzDynamic && sgzDynamic.activated === false) {
            setPillColor(global.lvzColors["deactivate"].cssColorName)
            setPillText("INDISPONIBLE")
        } else if (sgzDynamic && sgzDynamic.availability) {
            const freeSlots = sgzDynamic.free_slots || 0
            setPillColor(global.lvzColors[sgzDynamic.availability].cssColorName)
            setPillText(freeSlots + " PLACES")
        } else {
            setPillColor("")
            setPillText("")
        }

        if (sgzStatic && sgzStatic.location) {
            const destination = { lat: userLocation.lat, lng: userLocation.lng }
            const fetchTimes = async () => {
                try {
                    let drivingData = await getDriveTimeAndPath(destination, sgzStatic.location)
                    setDrivingTime(drivingData.driveTime)
                } catch (e) { /* ignore */ }
                try {
                    let walkData = await getWalkingTime(destination, sgzStatic.location)
                    setWalkingTime(walkData)
                } catch (e) { /* ignore */ }
            }
            fetchTimes()
        }

    }, [displaySgzPanel])

    if (!staticData) return null

    return (
        <>
            <div className='specific-detail-panel-container flex-center-column'>
                <div onClick={closePanel}>
                    <IoIcon.IoClose
                        style={{ color: "var(--blue)", width: "20px", height: "20px" }}
                    />
                </div>

                <div className="flex-space-between-inline" style={{ width: "100%" }}>
                    <div className="text-parking-div">
                        <p className="blue-title">{staticData.name ? staticData.name.toUpperCase() : "STREET GAUGE ZONE"}</p>
                    </div>
                    <div className="flex-flex-end-column" style={{ position: "relative" }}>
                        <div style={{ width: "30px", height: "30px", position: "absolute", left: "-15px", top: '-15px' }}>
                            <LiveIndic />
                        </div>
                        {dynamicData && (dynamicData.availability || dynamicData.activated === false) &&
                            <PillBadge
                                backgroundColor={pillColor}
                                text={pillText}
                            />
                        }
                        <p className="grey-subtitle">DANS LA RUE</p>
                    </div>
                </div>

                <div className="flex-space-between-inline pinfo_parkings" style={{ width: "100%", height: "15vh" }}>
                    <div className="flex-center-column pinfo_container">
                        <div className="grid-container">
                            <div className="grid-item">
                                <MdIcon.MdDriveEta
                                    style={{ color: "var(--grey)", width: "25px", height: "25px" }}
                                />
                            </div>
                            <div className="grid-item">
                                <span className="blue-text">{drivingTime}min</span>
                            </div>
                            <div className="grid-item">
                                <MdIcon.MdDirectionsWalk
                                    style={{ color: "var(--grey)", width: "25px", height: "25px" }}
                                />
                            </div>
                            <div className="grid-item">
                                <span className="blue-text">{walkingTime}min</span>
                            </div>
                        </div>
                    </div>
                    <div className="flex-center-column pinfo_container">
                        <div>
                            <p className="grey-text">Capacité</p>
                            <p className="blue-text">{dynamicData ? (dynamicData.total_slots || "-") : "-"} places</p>
                        </div>
                    </div>
                </div>

                <div className="flex-space-around-inline pactions-parkings">
                    <button className="pactions-button" onClick={() => { setShowPopupButtonGo(true) }}>
                        <img style={{ cursor: "pointer", width: "25px", verticalAlign: "middle" }} src="https://img.icons8.com/color/96/000000/google-maps.png" alt="" />
                        <img style={{ cursor: "pointer", width: "25px", verticalAlign: "middle" }} src="https://img.icons8.com/color/96/000000/waze.png" alt="" />
                        Go !
                    </button>
                </div>
            </div>
            {showPopupButtonGo && staticData.location ?
                <ButtonGoPopup setTrigger={setShowPopupButtonGo} destination={staticData.location} /> : null
            }
        </>
    )
}

export default SgzSpecificDetailsPanel
